import { lazy } from 'react';

export default {
  path: '/feedback',
  component: lazy(() => import(/* webpackChunkName: 'Feedback' */ './page'))
};
